import React from 'react';

const StatusCodeContext = React.createContext({});

export default StatusCodeContext;
